exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".regular-workshop-module-content p{padding-bottom:20px}.regular-workshop-module-content p span{word-wrap:break-word}.card-avatar-wrap-inner{object-fit:cover}.card-avatar-wrap-inner .has-ava{position:relative;width:118px;height:118px;border-radius:50%;background-color:#fff;overflow:hidden;object-fit:cover}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded!./src/styles/css/workshop-details.scss
// module id = 977
// module chunks = 0